import NChips from './NChips.vue';

export default NChips;